<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon color="white">edit</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Confirm Edit Bulb</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <v-card-text>
          WARNING: If this Bulb is being used in a Live Course, all edits will immediately be reflected in the linked Bulb, even if Save & Exit has not been clicked. Click 
          <a class="branded-color" target="_blank" href='https://knowledge.playposit.com/article/256-bulb-changed'>here</a> to learn more about what edits will impact learners.
          <br/>
        </v-card-text>
      </v-card>
      <v-divider></v-divider>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="setDashModal(null)">Cancel</v-btn>
        <div class="row-center">
          <v-btn
            v-if="!dashModal.admin"
            class="branded-background text-white"
            :href="dashModal.designerURL"
            @click="setDashModal(null)"
            target="_blank">
            Edit
          </v-btn>
          <v-btn
            v-else
            class="branded-background text-white"
            @click="handleAdminEdit">
            Edit
          </v-btn>
        </div>
      </v-card-actions>
  </v-card>
</template>

<script>
/**
 * Popover modal to confirm an instructor is about to edit a bulb.
 **/
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  name: 'ConfirmEditBulb',
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
    handleAdminEdit() {
      this.$store.dispatch('admin/getBulbRolePermission', this.dashModal.bulbId);
      this.setDashModal(null);
    },
  },
  computed: {
    ...mapState([
      'dashModal',
    ]),
  },
};
</script>